// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1nd5Y","calendarButtons":"ClockData_calendarButtons__3b8r7"};